import { Radio as AntRadio, RadioGroupProps, RadioProps as AntRadioProps } from "antd";
import { SVGs } from "../assets";
import Flex from "./flex";
import Text from "./text";
import React from "react";

interface RadioProps extends AntRadioProps {
  label?: string;
  postAddon?: React.ReactNode | null;
}

interface GroupProps extends Omit<RadioGroupProps, "options"> {
  options?: RadioProps[];
  vertical?: boolean;
  postAddon?: (option: any) => React.ReactNode;
}

const RadioItem = ({
  label,
  className = "",
  checked = false,
  onChange = () => {},
  postAddon = null,
  ...props
}: RadioProps) => {
  return (
    <Flex
      gap={"1rem"}
      align="center"
      className={"cursor-pointer " + className}
      onClick={(e) => onChange({ ...e, target: { checked } })}
      {...props}
    >
      <img
        alt=""
        style={{ width: "2.2rem", height: "2.2rem" }}
        src={checked ? SVGs.radioActive : SVGs.ringOutlined}
      />
      {label && <Text color="secondary" children={label} />}
      {postAddon}
    </Flex>
  );
};

const Group = ({
  vertical = false,
  value = "",
  options = [],
  onChange = () => {},
  postAddon = () => null,
  ...props
}: GroupProps) => {
  return (
    <Flex
      {...props}
      gap={"1rem"}
      vertical={vertical}
      children={React.Children.toArray(
        options.map((option) => {
          option.checked = value === option.value;
          return (
            <RadioItem
              {...option}
              postAddon={postAddon(option)}
              onChange={(e) => {
                if (option.disabled) return;
                onChange({
                  ...e,
                  target: { value: option.value, checked: option.checked!! },
                });
              }}
            />
          );
        })
      )}
    />
  );
};

const Radio = Object.assign(RadioItem, {
  Group,
  Button: AntRadio.Button,
  ButtonGroup: AntRadio.Group,
});

export default Radio;
